module.exports = __webpack_public_path__ + "static/media/devops.c3bee4f2.png";